import {
  CustomerDeactivationModalKey,
  CustomerDetailsKey,
  CustomerListPageKey,
  CustomerListTableKey,
  CustomerPendingListTableKey,
  CustomerUploadModalKey
} from '../../TModules';

export const translations = {
  [CustomerListTableKey]: {
    Identifier: 'Identificatore',
    Name: 'Nome',
    Status: 'Stato',
    DateJoined: 'Data di adesione',
    Actions: 'Azioni',
    SearchCustomers: 'Cerca clienti',
    Activate: 'Attiva',
    Deactivate: 'Disattiva',
    Active: 'Attivo',
    Inactive: 'Inattivo',
    Initial: 'Iniziale'
  },
  [CustomerUploadModalKey]: {
    HandleUpload: {
      SuccessMessage: 'File caricato',
      ErrorMessage: 'Errore durante il caricamento del file.',
      Title: 'Carica file cliente',
      OkText: 'Carica',
      CancelText: 'Annulla',
      UploadButton: 'Carica',
      UploadDraggerMessage: "Fare clic o trascinare il file in quest'area per caricarlo",
      DownloadSample: 'Scarica esempio',
      AcceptedFormat: 'Formato accettato: solo file .txt., .xlsx o .csv'
    }
  },
  [CustomerPendingListTableKey]: {
    RequestId: 'ID richiesta',
    Customer: 'Cliente',
    RequestType: 'Tipo di richiesta',
    Status: 'Stato',
    Comment: 'Commento',
    LastUpdated: 'Ultimo aggiornamento',
    DateOfExpiry: 'Data di scadenza',
    Actions: 'Azioni',
    Comments: 'Commenti',
    ViewDetails: 'Visualizza dettagli',
    Approve: 'Approva',
    ApproveRequests: 'Approva richieste',
    CustomerStampView: 'Vista timbro cliente',
    LoyaltyProgramDetails: 'Programma bonus dettagli',
    CustomerGameView: 'Vista gioco cliente',
    CustomerRewardView: 'Vista ricompensa cliente',
    ApproveSelectedButton: 'Approva selezionati',
    ReactivateCustomer: 'Riattiva Cliente',
    DeactivateCustomer: 'Disattiva Cliente',
    VoidVoucher: 'Annulla Voucher',
    ModifyVoucher: 'Modifica Voucher',
    CashbackIssue: 'Problema Di Cashback',
    Issue: 'Problema',
    Rewards: 'Ricompense',
    Reward: 'Ricompensa',
    Stamps: 'Timbri',
    Gametries: 'Tentativi Di Gioco',
    GameTries: 'Tentativi Di Gioco',
    GAMETRIES: 'TENTATIVI DI GIOCO',
    Voucher: 'Voucher',
    LoyaltyPoints: 'Punti Fedeltà',
    Cashbackissue: 'Emissione di Cashback',
    Loyaltydelete: 'Eliminazione della fedeltà',
    AddProgressPoints: 'Aggiungi punti progresso',
    MarkQuestTaskComplete: 'Segna attività quest come completata',
    IssueInstantReward: 'Emetti ricompensa istantanea',
    IssueRaffleTicket: 'Emetti biglietto lotteria',
    CustomerProgressPointsPendingView: 'Punti progresso in attesa',
    CustomerQuestTaskPendingView: 'Attività quest in attesa',
    CustomerInstantRewardPendingView: 'Ricompensa istantanea in attesa',
    CustomerRaffleTicketPendingView: 'Biglietto lotteria in attesa',

    ApproveMultipleMessageModal: {
      SuccessMessage: 'Upload approvati',
      FailureMessage: 'Errore nell’approvazione del file.',
      Title: 'Approvare più richieste?',
      OkText: 'Approva selezionati',
      DescriptionText: `
      Sei sicuro di voler approvare tutte le richieste selezionate?
      <br />
      Verifica i dettagli prima di approvare poiché questa azione non può essere annullata.`
    },
    ApproveRequestModal: {
      SuccessMessage: 'Richiesta approvata',
      FailureMessage: `Errore nell'approvazione della richiesta.`,
      Title: 'Approvare la richiesta?',
      OkText: 'Approva',
      DescriptionText: `Sei sicuro di voler approvare questa richiesta?`
    },
    UploadCommentModal: {
      ViewAndAddComments: 'Visualizza e aggiungi commenti',
      Content: 'Contenuto',
      DeleteButton: 'Pulsante elimina',
      Time: 'Tempo',
      ErrorAddingComment: 'Errore nell’aggiunta del commento',
      CommentAdded: 'Commento aggiunto',
      EnterYourCommentHere: 'Inserisci qui il tuo commento',
      AddComment: 'Aggiungi commento',
      CommentsAdded: 'Commenti aggiunti',
      Delete: 'Elimina'
    },
    DeleteCommentModal: {
      CommentDeleted: 'Commento eliminato',
      ErrorDeletingComment: 'Errore nell’eliminazione del commento',
      DeleteComment: 'Eliminare il commento?',
      Delete: 'Elimina',
      DescriptionFirstLine: `Sei sicuro di voler eliminare il tuo commento?`,
      DescriptionSecondLine: `Questa azione non può essere annullata.`
    }
  },
  [CustomerListPageKey]: {
    PendingRequests: 'Richieste in sospeso',
    Customers: 'Clienti',
    CustomersList: 'Elenco clienti',
    Upload: 'Carica',
    TransactionRequests: 'Richieste di transazione',
    DeactivatingCustomer: 'Disattivazione Cliente...',
    DeactivationRequestSubmitted: 'Richiesta Di Disattivazione Cliente Inviata Per Approvazione!',
    SuccessfullyDeactivated: 'Disattivazione Riuscita!',
    DeactivationFailed: 'Disattivazione Fallita',
    SuccessfullyDeleted: 'Eliminazione Riuscita!',
    DeletingCustomer: 'Eliminazione Cliente...',
    ActivatingCustomer: 'Attivazione Cliente...',
    ActivationRequestSubmitted: 'Richiesta Di Attivazione Cliente Inviata Per Approvazione!',
    SuccessfullyActivated: 'Attivazione Riuscita!',
    ActivationFailed: 'Attivazione Fallita',
    LoadingCustomer: 'Caricamento Cliente...',
    ErrorRetrievingCustomer: 'Qualcosa È Andato Storto!'
  },
  [CustomerDeactivationModalKey]: {
    ProvideReasonForDeactivation: 'Fornisci motivo per la disattivazione',
    ProvideReasonForActivation: 'Fornisci motivo per l’attivazione',
    Deactivate: 'Disattiva',
    Activate: 'Attiva',
    Cancel: 'Annulla',
    DeactivationReason: 'Seleziona il motivo'
  },
  [CustomerDetailsKey]: {
    ID: 'ID',
    CustomerDetails: 'Dettagli cliente',
    RewardsLabel: 'Indennità',
    Identifier: 'Identificatore',
    UserInfo: 'Informazioni utente',
    FirstName: 'Nome',
    MiddleName: 'Secondo nome',
    LastName: 'Cognome',
    Gender: 'Genere',
    Address: 'Indirizzo',
    Birthday: 'Compleanno',
    JoinedAt: 'Iscritto il',
    CreatedVia: 'Creato tramite',
    ReferralCode: 'Codice di riferimento',
    Email: 'Email',
    Phone: 'Telefono',
    State: 'Stato',
    City: 'Città',
    Race: 'Razza',
    Segment: 'Segmento',
    AccountId: 'ID account',
    Nationality: 'Nazionalità',
    AlternateId: 'ID alternativo',
    ProductType: 'Tipo di prodotto',
    Classification: 'Classificazione',
    LocationState: 'Stato della posizione',
    PreferredLanguage: 'Lingua preferita',
    FindRewardByNameTypeOrMerchant: 'Trova indennità per nome, tipo o commerciante',
    IssueRewards: "Emettere l'indennità",
    ErrorRetrievingCustomer: 'Errore nel recupero del cliente',
    CustomerRewards: 'Ricompense cliente',
    LoyaltyProgram: 'Programma bonus',
    AccountDetails: 'Dettagli account',
    Campaigns: 'Campagne',
    EventLogs: {
      TabLabel: 'Log eventi',
      Filters: {
        EventName: 'Nome evento',
        EventNamePlaceholder: 'Seleziona nome evento',
        Helper: 'Filtra l’elenco per nome evento'
      },
      Table: {
        ID: 'ID',
        EventName: 'Nome evento',
        Params: 'Parametri',
        State: 'Stato',
        CreatedAt: 'Creato il'
      },
      Detail: {
        Title: 'Dettaglio log evento',
        Back: 'Torna ai log eventi',
        RuleOutcomes: 'Esiti regole',
        Error: 'Impossibile caricare i dettagli del log evento.',
        NoData: 'Log evento non trovato.',
        Fields: {
          ID: 'ID',
          EventName: 'Nome evento',
          State: 'Stato',
          EventParams: 'Parametri evento',
          CreatedAt: 'Creato il',
          UpdatedAt: 'Aggiornato il',
          ProcessingStartedAt: 'Elaborazione iniziata il',
          ProcessingCompletedAt: 'Elaborazione completata il'
        }
      }
    },
    Transactions: {
      TabLabel: 'Transazioni',
      Filters: {
        State: 'Stato',
        StatePlaceholder: 'Seleziona stato',
        TransactionReference: 'Riferimento transazione',
        TransactionReferencePlaceholder: 'Inserisci riferimento transazione',
        CreatedAtRange: 'Intervallo date di creazione',
        CreatedAtRangeStartPlaceholder: 'Data inizio',
        CreatedAtRangeEndPlaceholder: 'Data fine',
        Helper: 'Filtra l’elenco per stato, riferimento o data di creazione'
      },
      Table: {
        ID: 'ID',
        Reference: 'Riferimento',
        Amount: 'Importo',
        Properties: 'Proprietà',
        State: 'Stato',
        CreatedAt: 'Creato il'
      },
      Detail: {
        Title: 'Dettaglio transazione',
        Back: 'Torna alle transazioni',
        Error: 'Impossibile caricare i dettagli della transazione.',
        NoData: 'Transazione non trovata.',
        RuleOutcomes: 'Esiti regole',
        Fields: {
          ID: 'ID',
          Reference: 'Riferimento',
          Amount: 'Importo',
          State: 'Stato',
          CreatedAt: 'Creato il',
          UpdatedAt: 'Aggiornato il',
          TransactionDate: 'Data transazione',
          TransactionType: 'Tipo transazione',
          Currency: 'Valuta',
          ProcessedAt: 'Elaborato il',
          ProcessAt: 'Elabora il',
          TransactionStatus: 'Stato transazione',
          UniqueTransactionId: 'ID transazione univoco',
          UserAccountId: 'ID account utente',
          AmountPoint: 'Importo punti',
          MerchantUserAccountId: 'ID account utente commerciante',
          WorkflowId: 'ID workflow',
          Properties: 'Proprietà'
        }
      }
    },
    RuleOutcomesTable: {
      RuleOutcomeId: 'ID esito regola',
      TransactionRuleId: 'ID regola transazione',
      TransactionRuleName: 'Nome regola transazione',
      State: 'Stato',
      AdditionalInfo: 'Informazioni aggiuntive',
      Empty: 'Nessun esito di regola disponibile.'
    },
    FilteringChecks: {
      TabLabel: 'Verifiche di filtro',
      RewardTabLabel: 'Filtro ricompense',
      CampaignTabLabel: 'Filtro campagne',
      HelperText:
        'Esegui un controllo per vedere quali filtri passano o falliscono per questo cliente.',
      PassedFilters: 'Filtri superati',
      FailedFilters: 'Filtri non superati',
      NoPassedFilters: 'Nessun filtro superato',
      NoFailedFilters: 'Nessun filtro non superato',
      GenericError: 'L’ID cliente non è valido.',
      NotFoundError: '404 non trovato',
      ToggleHide: 'Nascondi sezione',
      ToggleShow: 'Mostra sezione',
      Reward: {
        Title: 'Verifica filtro ricompense',
        Description:
          'Inserisci un ID cliente per vedere quali filtri includono o escludono questo cliente per la ricompensa.',
        Placeholder: 'Inserisci ID cliente',
        InputLabel: 'ID cliente',
        Button: 'Verifica filtri cliente',
        MissingIdError: 'Inserisci un ID cliente'
      },
      Campaign: {
        Title: 'Verifica filtro campagne',
        Description:
          'Inserisci un ID cliente per vedere quali filtri includono o escludono questo cliente per la campagna.',
        Placeholder: 'Inserisci ID cliente',
        InputLabel: 'ID cliente',
        Button: 'Verifica filtri cliente',
        MissingIdError: 'Inserisci un ID cliente'
      }
    },
    CustomerIDNotFound: 'ID cliente non trovato',
    DeleteUser: 'Elimina utente',
    Activate: 'Attiva',
    Deactivate: 'Disattiva',
    ACTIVE: 'ATTIVO',
    Inactive: 'Inattivo',
    DeactivationReason: 'Motivo della disattivazione',

    RewardIssueMakerCheckerErrorMessage: 'Non puoi approvare la tua richiesta',
    RewardIssueErrorMessage: "Si è verificato un errore durante l'assegnazione dei premi",
    RewardIssueErrorsOccurredWhileIssuingRewards:
      "Si sono verificati errori durante l'emissione di premi",
    RewardIssueSuccessMessage: 'Premio emesso con successo',
    RewardIssueMakerCheckerSuccessMessage:
      "Richiesta di emissione del premio inviata per l'approvazione",
    RewardIssueUnexpectedResponseFormat: 'Formato di risposta inaspettato',
    Stamps: 'carte fedeltà',
    Games: 'Giochi',
    ProgressCampaign: 'Campagna sul progresso',
    AddressState: "Stato dell'indirizzo",
    AddressCity: 'Affronta la città',
    Company: 'Azienda',
    EmailTags: 'Tag e -mail',
    BusinessType: 'Tipo di attività',
    INACTIVE: 'INATTIVO',
    Cashback: 'Cashback',

    Name: 'Nome',
    Status: 'Stato',
    Tenure: 'Durata',
    Tier: 'Livello',
    Balance: 'Saldo',
    ToNextTier: 'Al prossimo livello',
    MembershipExpiry: 'Scadenza dell’iscrizione',

    CashbackModal: {
      CancelIssuanceModal: {
        Title: 'Annullare la richiesta di emissione del cashback?',
        MessageLineOne:
          'La richiesta di emissione è in attesa di approvazione. Sei sicuro di volerla annullare?'
      },
      ApproveIssuanceModal: {
        Title: 'Approvare l’emissione del cashback',
        MessageLineOne:
          'Sei sicuro di voler approvare questa emissione di cashback? Questa azione non può essere annullata.'
      }
    },

    Rewards: {
      FindRewardByNameTypeOrMerchant: 'Trova indennità per nome, tipo o commerciante',
      IssueRewardsManually: "Emettere l'indennità manualmente",
      Issued: 'Emesso',
      Pending: 'In sospeso',
      GiftedAway: 'Regalato',
      Redeemed: 'Riscattato',
      RedemptionInProgress: 'Riscatto in corso',
      FullyRedeemed: 'Completamente riscattato',
      Voided: 'Annullato',
      Expired: 'Scaduto',
      Archived: 'Archiviato',

      Name: 'Nome',
      DeletionRequested: 'Eliminazione richiesta',
      ID: 'ID',
      Merchant: 'Commerciante',
      DateOfIssued: 'Data di emissione',
      ValidFrom: 'Valido dal',
      ValidTo: 'Valido fino al',
      VoucherCode: 'Codice voucher',
      AdminFee: 'Commissione amministrativa',
      Action: 'Azione',
      DateOfExpired: 'Data di scadenza',
      DateOfGifted: 'Data di regalo',
      DateOfRedeemed: 'Data di riscatto',
      RequestId: 'ID richiesta',
      Status: 'Stato',
      RewardId: 'ID ricompensa',
      IssuedOn: 'Emesso il',

      RequestType: 'Tipo di richiesta',
      CancelVoidRequest: 'Annulla la richiesta vuota',
      CancelUpdateRequest: 'Annulla la richiesta di aggiornamento',
      CancelIssueRequest: 'Annulla richiesta di emissione',
      ErrorApprovingRewards: 'Si è verificato un errore durante l’approvazione delle ricompense',

      VoidVoucher: 'Annulla voucher',
      ChangeExpiryDate: 'Modifica data di scadenza',
      AmendReward: 'Modifica ricompensa',
      UndoRedeem: 'Annulla riscatto',
      ThereIsNoActionForGiftedVoucher: 'Nessuna azione per voucher regalato.',
      RevertBackToIssued: 'Torna a emesso',
      WaiveAdminFee: 'Elimina commissione amministrativa',
      DeleteReward: 'Elimina ricompensa',
      ViewComments: 'Visualizza commenti',
      ApproveIssue: 'Approva emissione',

      ViewAndAddComments: 'Visualizza e aggiungi commenti',
      RequestHasBeenApproved: 'Richiesta approvata',
      SomethingWentWrong: 'Qualcosa è andato storto',
      HandleUndoRedeemErrorMessage:
        'Non è possibile annullare il riscatto - modifica la data di scadenza e riprova.',
      HandleUndoRedeemConfirmModalTitle: 'Conferma',
      HandleUndoRedeemConfirmModalMessage:
        'Questo riporterà lo stato del voucher a Emesso - continuare?',

      HandleVoidVoucherMakerCheckerSuccessMessage:
        'Richiesta di annullamento inviata per approvazione',
      HandleVoidVoucherSuccessMessage: 'Voucher annullato',
      HandleVoidVoucherConfirmModalMakerCheckerRightButtonText: 'Richiedi annullamento',
      HandleVoidVoucherConfirmModalRightButtonText: 'Conferma',
      HandleVoidVoucherConfirmModalMakerCheckerTitle: 'Inviare richiesta di annullamento?',
      HandleVoidVoucherConfirmModalTitle: 'Conferma',
      HandleVoidVoucherConfirmModalMakerCheckerMessage:
        'Sei sicuro di voler richiedere l’annullamento del voucher premio? Una volta approvato, non potrai ripristinarlo.',
      HandleVoidVoucherConfirmModalMessage: 'Questo annullerà il voucher premio - continuare?',

      HandleRevertRedemptionToIssuedConfirmModalTitle: 'Conferma',
      HandleRevertRedemptionToIssuedMessageConfirmModalMessage:
        'Questo riporterà lo stato del voucher a Emesso - continuare?',

      ShowOCBCDemoConfirmModalTitle: 'Conferma',
      ShowOCBCDemoConfirmModalMessage:
        'Questo eliminerà la commissione amministrativa - continuare?'
    },

    IssueRewardsModal: {
      Title: "Emettere l'indennità manualmente",
      OkText_one: 'Emettere {{count}} indennità',
      OkText_other: 'Emettere {{count}} indennità',
      SearchPlaceholder: 'Trova indennità per nome, tipo o commerciante',
      ActiveTabLabel: 'Attivo',
      PrivateTabLabel: 'Privato',
      CancelText: 'Cancellare',

      CustomerRewardsConfirmationModal: {
        RewardName: 'Nome della remunerazione',
        RewardPrices: 'Prezzi Ricompensa',
        FreeOrPaid: 'Gratuito/A Pagamento',
        ConfirmSellPrice: 'Conferma Prezzo di Vendita',
        And: 'e',
        Points: 'punti',
        Or: 'O',
        Paid: 'A Pagamento',
        Free: 'Gratuito',
        Cancel: 'Annulla',
        IssueRewards: "EMETTERE L'INDENNITÀ"
      }
    },
    IssueRewardsTable: {
      Name: 'Nome',
      Merchant: 'Commerciante',
      ValidityPeriod: 'Periodo di validità',
      Balance: 'Saldo'
    },
    AuditLog: {
      Title: 'Registro di controllo',
      LastUpdatedAt: 'Ultimo aggiornamento alle',
      IpAddress: 'Indirizzo IP',
      User: 'Utente',
      Action: 'Azione',
      Description: 'Descrizione',
      RenderSummaryIsCreated: 'creato',
      RenderSummaryIsUpdated: 'aggiornato',

      Details: 'Dettagli',
      Old: 'Vecchio',
      New: 'Nuovo',
      Audience: {
        Created: 'Audience created',
        NameUpdated: 'Audience name updated',
        FiltersUpdated: 'Filter customers updated',
        FileUploaded: 'Audience File uploaded',
        FileRemoved: 'Audience File removed',
        FileRelationChanged: 'Audience File relation changed',
        Uploaded: 'uploaded',
        Removed: 'removed',
        RelationChangedTo: 'relation changed to',
        NameLabel: 'Audience name',
        Criteria: {
          Age: 'Age',
          Gender: 'Gender',
          CustomAttributes: 'Custom Attributes'
        },
        AttributeGroup: 'Customer attributes',
        AttributeGroupRaw: 'Customer attributes (excluded group)'
      },
      DetailsColumn: {
        AutoFillStamps: 'Riempimento automatico timbri',
        Wedges: 'Spicchi',
        LandingPage: 'Pagina di destinazione',
        EnrolmentType: 'Tipo di iscrizione',
        AutoEnrolUsers: 'Iscrizione automatica utenti',
        State: 'Stato',
        NameEn: 'Nome in inglese',
        Ordering: 'Ordinamento',
        Timezone: 'Fuso orario',
        StartDate: 'Data di inizio',
        AutoIssueMoves: 'Mosse automatiche',
        TypeOfCampaign: 'Tipo di campagna',
        OutcomesPerMove: 'Risultati per mossa',
        TypeOfCampaignReferral: 'Tipo di referral campagna',
        Rewards: 'Ricompense',
        PeriodUnits: 'Unità di periodo',
        RewardsOrdering: 'Ordinamento ricompense',
        NoOfStampsPerRow: 'Numero di timbri per riga',
        TotalStampsOnCard: 'Totale timbri sulla carta',
        DisplayPropertiesEn: 'Proprietà di visualizzazione in inglese',
        DisplayPropertiesTh: 'Proprietà di visualizzazione in thailandese',
        DisplayPropertiesVi: 'Proprietà di visualizzazione in vietnamita',
        DisplayPropertiesZh: 'Proprietà di visualizzazione in cinese',
        NoOfStampsPerColumn: 'Numero di timbri per colonna',
        CampaignIntervalPeriod: 'Periodo di intervallo campagna',
        DisplayPropertiesZhHans: 'Proprietà di visualizzazione in cinese semplificato',
        DisplayPropertiesZhHant: 'Proprietà di visualizzazione in cinese tradizionale',

        Header: 'Intestazione',
        CardImage: 'Immagine carta',
        ButtonText: 'Testo pulsante',
        ThumbnailImage: 'Immagine miniatura',
        ButtonBgColour: 'Colore sfondo pulsante',
        GiftActiveImage: 'Immagine regalo attiva',
        ButtonTextColour: 'Colore testo pulsante',
        StampActiveImage: 'Immagine timbro attiva',
        DisplayCampaignAs: 'Mostra campagna come',
        GiftInactiveImage: 'Immagine regalo inattiva',
        ButtonExternalLink: 'Link esterno pulsante',
        StampInactiveImage: 'Immagine timbro inattiva',
        CardBackgroundImage: 'Immagine sfondo carta',
        Cols: 'Colonne',
        Rows: 'Righe',
        Tags: 'Tag',
        Labels: 'Etichette',
        Referee: 'Referente',
        Categories: 'Categorie',
        DescriptionEn: 'Descrizione in inglese',
        TermsAndConditionsEn: 'Termini e condizioni in inglese',
        RefereeTotalRewardLimit: 'Limite totale ricompensa referente',
        ClaimPrize: 'Richiedi premio',
        StampsAwarded: 'Timbri assegnati',
        Status: 'Stato',
        Value: 'Valore',
        Operators: 'Operatori',
        RuleName: 'Nome regola',
        Body: 'Corpo',
        MilestonesSuccessImage: 'Immagine successo traguardi',
        SelectRuleAttribute: 'Seleziona attributo regola',
        EndDate: 'Data di fine',
        GrandPrizeOutcome: 'Risultato premio principale',
        RaffleTicketOutcome: 'Risultato biglietto lotteria'
      }
    },
    DeleteCustomerModal: {
      MakesCheckerErrorMessage: "Implementa l'integrazione dell'API con il Checker Maker in corso",
      Title: 'Eliminare utente?',
      OkText: 'conferma',
      CancelText: 'Torna indietro',
      DescriptionLineOne: 'Sei sicuro di voler eliminare questo utente?',
      DescriptionLineTwo: 'Questa azione non può essere annullata.',
      Name: 'Nome:',
      Identifier: 'Identificatore:'
    },

    LoyaltyProgramsTable: {
      Name: 'Nome',
      Status: 'Stato',
      Tenure: 'Durata',
      Tier: 'Livello',
      Balance: 'Saldo',
      ToNextTier: 'Al prossimo livello',
      MembershipExpiry: 'Scadenza dell’iscrizione',
      Actions: 'Azioni'
    },
    LoyaltyProgramDetailsModal: {
      Title: 'Programma bonus dettagli',
      CloseButton: 'CHIUDI',
      Active: 'Attivo',
      Pending: 'In sospeso',
      Actions: 'Azioni',
      ActionCancelRequest: 'Annulla richiesta',
      ActionApproveIssue: 'Approva emissione',
      ActionApproveDeletion: 'Approva eliminazione',
      ActionDenyDeletion: 'Nega eliminazione',
      ActionComments: 'Commenti',
      ActionCommentsModalTitle: 'Visualizza e aggiungi commenti',

      CancelIssuance: "Annullare l'emissione",
      CancelDeletion: 'Annulla eliminazione',

      Event: 'Evento',
      EventButton: 'Eliminazione richiesta',
      Carryforward: 'Riporto',
      Status: 'Stato',
      SubmissionDate: 'Data di presentazione',
      Points: 'Punti',
      ExpiresAt: 'Scade il',
      TransactionId: 'ID transazione',
      LoyaltyTransactionId: 'ID transazione fedeltà',
      AmountTransacted: 'Importo transato',
      TransactionAmount: 'Importo della transazione',
      TransactionDate: 'Data transazione',
      Date: 'Data',
      TransactionRef: 'Rif. transazione',
      AwardingTransactionId: 'ID transazione di assegnazione',
      Properties: 'Proprietà',
      Merchant: 'Commerciante',
      GlAccountNumber: 'Numero conto GL',
      CostCenterId: 'ID centro di costo',
      BranchCode: 'Codice filiale',

      ChangeStatus: 'Cambia stato',
      ChangeTier: 'Cambia livello',
      AddOrRemovePoints: 'Aggiungi / Rimuovi punti',
      AmountIsRequired: 'L’Importo È Obbligatorio',
      AmountMustBeNonZero: 'L’Importo Deve Essere Diverso Da Zero',

      PointsAwarded: 'Punti Assegnati',

      ChangeStatusForm: {
        Active: 'Attivo',
        Inactive: 'Inattivo',
        Save: 'Salva'
      },
      ChangeTierForm: {
        Label: 'Sovrascrivi livello scade il:',
        Save: 'Salva'
      },
      PointsForm: {
        SelectGlAccount: 'Seleziona conto GL',
        GlAccountType: 'Tipo conto GL',
        GlAccountName: 'Nome conto GL',
        Message: 'Scrivi un messaggio per accompagnare questa regolazione punti.',
        AdjustPointsButton: 'Regola punti',
        GLAccountIdIsRequired: 'ID Del Conto GL È Obbligatorio',
        GLAccountTypeIsRequired: 'Tipo Di Conto GL È Obbligatorio',
        GLAccountNameIsRequired: 'Nome Del Conto GL È Obbligatorio'
      },
      UpdateLoyaltyProgramCustomerStateSuccessMessage: 'Stato aggiornato',
      UpdateLoyaltyProgramCustomerStateErrorMessage: 'qualcosa è andato storto',
      UpdateLoyaltyProgramCustomerTierSuccessMessage: 'Livello aggiornato',
      UpdateLoyaltyProgramCustomerTierErrorMessage: 'qualcosa è andato storto',
      CreateCustomerLoyaltyTransaction: {
        GLAccountTypeRequiredMessage: 'È richiesto il tipo di conto GL',
        GlAccountNameRequiredMessage: 'È richiesto il nome del conto GL',
        MakerCheckerSuccessMessage: 'Richiesta di emissione punti inviata per approvazione',
        SuccessMessage: 'Transazione aggiunta',
        ErrorMessage: 'qualcosa è andato storto'
      },
      DeleteCustomerRequestLoyaltyTransaction: {
        SuccessMessage: 'Richiesta annullata',
        ErrorMessage: 'qualcosa è andato storto'
      },
      ApproveDenyCustomerRequestLoyaltyTransaction: {
        RequestHasBeenDeletedMessage: 'La richiesta è stata eliminata',
        RequestHasBeenApprovedMessage: 'La richiesta è stata approvata',
        ApproveSuccessMessage: 'La richiesta è stata ',
        ErrorMessage: 'qualcosa è andato storto'
      },
      DeleteCustomerLoyaltyTransaction: {
        MakerCheckerSuccessMessage:
          'Richiesta di eliminazione transazione inviata per approvazione',
        SuccessMessage: 'Transazione eliminata',
        ErrorMessage: 'qualcosa è andato storto'
      },
      RecoverCustomerLoyaltyTransaction: {
        SuccessMessage: 'Transazione recuperata',
        ErrorMessage: 'qualcosa è andato storto'
      },
      DeleteCustomerLoyaltyTransactionModal: {
        ActiveTitle: 'Inviare richiesta di eliminazione?',
        ActiveOkText: 'Richiedi eliminazione',
        ActiveCancelText: 'Annulla',
        CancelText: 'Indietro',
        ActiveMessage:
          'Sei sicuro di voler richiedere l’eliminazione di questi punti? Una volta approvato, non potrai ripristinarli.',
        MessageLineOne: `L'emissione di questi punti è in attesa di approvazione. Sei sicuro di voler annullare la richiesta?`,
        MessageLineTwo: 'Questa azione non può essere annullata.',

        CancelDeletionTitle: 'Annullare la richiesta di eliminazione punti?',
        Title: 'Annullare la richiesta di emissione punti?',
        OkText: 'Confermare',
        MessageLineOneDeletion: 'La cancellazione di questi punti è in attesa di approvazione. '
      },
      ApproveDenyModal: {
        DenyDeletionOkText: 'Nega',
        OkText: 'Approva',
        ApproveIssueTitle: "Approvare l'emissione di punti fedeltà",
        ApproveDeletionTitle: 'Approva la cancellazione dei punti fedeltà',
        DenyDeletionTitle: 'Nega la richiesta di eliminazione dei punti fedeltà',
        ApproveIssueAndDeletionMessageLineOne: 'Sei sicuro di volerlo approvare?',
        ApproveIssueAndDeletionMessageLineTwo: 'di punti fedeltà? ',
        Message: 'Sei sicuro di voler negare la cancellazione di questi punti fedeltà? ',
        Issuance: 'emissione',
        Deletion: 'cancellazione'
      },

      LineProgressBar: {
        HeaderDateText: 'inizio periodo',
        CustomerTierText: 'L’utente si trova attualmente in',
        Tier: 'Livello',
        CustomerForcedMinimumTierText: 'L’utente è stato forzatamente inserito nel livello minimo',
        CustomerForcedMaximumTierText: `L’utente è stato `,
        FORCED: 'FORZATO',
        into: 'in',
        EndOfPeriod: 'fine periodo',
        ForcedTier: 'Livello forzato',
        ForcedMinTier: 'Livello minimo forzato',
        UserHasBeen: 'L’utente è stato',
        Forced: 'forzato',
        To: 'a',
        Status: 'stato',
        Until: 'fino a',
        DeleteForcedTierLinkText: 'X Disattiva Livello Forzato',
        ToMinimum: 'al minimo',
        TheUserHasEarned: 'L’utente ha guadagnato',
        Points: 'Punto/i',
        DuringThisCycle: 'durante questo ciclo.',
        TheUserRequires: 'L’utente necessita',
        ToLevelUpTo: 'per salire al livello',
        TheUserHas: 'L’utente ha',
        Available: 'disponibile.'
      }
    },

    CashbackTable: {
      CashbackTransactionID: 'Cashback Transaction ID',
      Event: 'Événement',
      CashbackAmount: 'Montant du Cashback',
      Currency: 'Devise',
      Date: 'Date',
      CashbackRuleID: 'ID de la règle de Cashback',
      TransactionID: 'ID de la transaction',
      TransactionAmount: 'Montant de la transaction',
      LoyaltyProgramID: 'ID du programme de fidélité',
      Points: 'Points',
      IssueCashback: 'Émettre un Cashback',
      AvailablePoints: 'Points disponibles',
      NoOfPointsToRedeem: 'Nombre de points à échanger',
      Back: 'Retour',
      InsufficientPoints: 'Points insuffisants',
      CashbackMaxError: 'Le montant du cashback ne peut pas dépasser',
      CashbackRuleIDIsRequired: "L'ID de la règle de cashback est requis",
      LoyaltyProgramIDIsRequired: "L'ID du programme de fidélité est requis",
      PointsAreRequired: 'Les points sont requis',
      PointsMustBeANumber: 'Les points doivent être un nombre',
      PointsMustBeAnInteger: 'Les points doivent être un entier',
      CashbackIssuedSuccessfully: 'Cashback émis avec succès',
      IssueCashbackRequestSubmittedSuccessfully:
        'Demande d’émission de cashback soumise avec succès'
    },

    CustomerCampaigns: {
      ID: 'ID',
      HitThePinata: 'Colpisci la pentolaccia',
      ScratchCard: 'Gratta e vinci',
      Plinko: 'Plinko',
      Name: 'Nome',
      CampaignType: 'Tipo di campagna',
      Status: 'Stato',
      StartDate: 'Data di inizio',
      EndDate: 'Data di fine',
      Actions: 'Azioni',
      SearchCampaignsPlaceholder: 'Cerca campagne',
      UnenrollCustomer: 'Annulla iscrizione cliente',
      NotStarted: 'Non iniziata',
      Active: 'Attiva',
      Completed: 'Completata',
      NotCompleted: 'Non completata',
      Enrollable: 'Iscrivibile',
      EndedAndNotEnrolled: 'Terminata e non iscritto',
      Enrolled: 'Iscritto',
      NotEnrolled: 'Non iscritto',
      SpinTheWheel: 'Gira la ruota',
      ShakeTheTree: 'Scuoti l’albero',
      EnrollCustomer: 'Iscrivi cliente',
      SelectCampaignsPlaceholder: 'Seleziona campagne',
      EnrollUserSuccessMessage: 'Campagna iscritta',
      UnenrollUserSuccessMessage: 'Campagna annullata',
      SomethingWentWrong: 'Qualcosa è andato storto',
      AddOrRemovePointsButton: 'Aggiungi/Rimuovi punti',

      SelectedTypeCampaigns: {
        Customers: 'Clienti',
        Campaigns: 'Campagne',
        StampCampaign: 'Campagna timbro',
        QuizCampaign: 'Campagna quiz',
        SurveyCampaign: 'Campagna sondaggio',
        GameCampaign: 'Campagna gioco',
        ProgressCampaign: 'Campagna progresso',
        QuestCampaign: 'Campagna missione',
        InstantRewardCampaign: 'Campagna ricompensa immediata',
        StreakCampaign: 'Campagna serie',
        CampaignProgress: 'Questo cliente è attualmente su'
      },

      RaffleView: {
        TriggerName: 'Nome trigger',
        RaffleRuleID: 'ID regola lotteria',
        TransactionDetails: 'Dettagli transazione',
        TransactionRuleID: 'ID regola transazione',
        TriggeredDateOrTime: 'Data attivazione',
        RaffleCode: 'Codice lotteria',
        State: 'Stato',
        Reversed: 'Annullato',
        ReversalReason: "Motivo dell'annullamento",
        ReversedAt: 'Annullato il',
        ReversedBy: 'Annullato da',
        System: 'Sistema'
      },

      InstantRewardView: {
        TriggerName: 'Nome trigger',
        RuleID: 'ID regola',
        TransactionDetails: 'Dettagli transazione',
        TriggeredDateOrTime: 'Data completamento',
        Ref: 'Rif'
      },

      QuestView: {
        TriggerName: 'Nome trigger',
        Task: 'Compito',
        QuestRuleID: 'ID regola missione',
        TransactionDetails: 'Dettagli transazione',
        TransactionRuleID: 'ID regola transazione',
        TriggeredDateOrTime: 'Data / Ora attivazione',
        State: 'Stato',
        Actions: 'Azioni',
        MarkCompleted: 'Segna come completato',
        MarkCompletedSuccessMessage: 'Punti aggiornati con successo!',
        MarkCompletedErrorMessage: 'Errore nell’aggiornamento dei punti'
      },

      CustomerProgressCard: {
        TriggerName: 'Nome trigger',
        ProgressRuleID: 'ID regola progresso',
        TransactionDetails: 'Dettagli transazione',
        TransactionRuleID: 'ID regola transazione',
        TriggeredDateOrTime: 'Data / Ora attivazione',
        Points: 'Punti',
        STAGE: 'STADIO',
        ThisCustomerIsCurrentlyOn: 'Questo cliente è attualmente su',
        FIRST: 'PRIMO',
        SECOND: 'SECONDO',
        THIRD: 'TERZO',
        FOURTH: 'QUARTO',
        FIFTH: 'QUINTO',
        SIXTH: 'SESTO',
        SEVENTH: 'SETTIMO',
        EIGHTH: 'OTTAVO',
        NINTH: 'NONO',
        TENTH: 'DECIMO',
        ELEVENTH: 'UNDICESIMO',
        TWELFTH: 'DODICESIMO',
        THIRTEENTH: 'TREDICESIMO',
        FOURTEENTH: 'QUATTORDICESIMO',
        FIFTEENTH: 'QUINDICESIMO',
        SIXTEENTH: 'SEDICESIMO',
        SEVENTEENTH: 'DICIASSETTESIMO',
        EIGHTEENTH: 'DICIOTTESIMO',
        NINETEENTH: 'DICIANNOVESIMO',
        TWENTIETH: 'VENTESIMO',
        TWENTYFIRST: 'VENTUNOESIMO',
        TWENTYSECOND: 'VENTIDUESIMO',
        TWENTYTHIRD: 'VENTITREESIMO',
        TWENTYFOURTH: 'VENTIQUATTRESIMO',
        TWENTYFIFTH: 'VENTICINQUESIMO',
        TWENTYSIXTH: 'VENTISEIESIMO',
        TWENTYSEVENTH: 'VENTISETTESIMO',
        TWENTYEIGHTH: 'VENTOTTESIMO',
        TWENTYNINTH: 'VENTINOVESIMO',
        THIRTITH: 'TRENESIMO',
        THIRTYFIRST: 'TRENTUNOESIMO',
        THIRTYSECOND: 'TRENTADUESIMO',
        THIRTYTHIRD: 'TRENTATREESIMO',
        THIRTYFOURTH: 'TRENTATUARESIMO',
        THIRTYFIFTH: 'TRENTA‐CINQUESIMO',
        THIRTYSIXTH: 'TRENTA-SEIESIMO',
        THIRTYSEVENTH: 'TRENTA-SETTESIMO',
        THIRTYEIGHTH: 'TRENTA-OTTESIMO',
        THIRTYNINTH: 'TRENTA-NOVESIMO',
        FORTIETH: 'QUARANTESIMO',
        FORTYFIRST: 'QUARANTUNOESIMO',
        FORTYSECOND: 'QUARANTADUESIMO',
        FORTYTHIRD: 'QUARANTATREESIMO',
        FORTYFOURTH: 'QUARANTATUARESIMO',
        FORTYFIFTH: 'QUARANTACINQUESIMO',
        FORTYSIXTH: 'QUARANTASEIESIMO',
        FORTYSEVENTH: 'QUARANTASETTESIMO',
        FORTYEIGHTH: 'QUARANTA-OTTESIMO',
        FORTYNINTH: 'QUARANTANOVESIMO',
        FIFTIETH: 'CINQUANTESIMO'
      },

      CustomerGameView: {
        TriesID: 'ID tentativi',
        Status: 'Stato',
        AcquiredVia: 'Acquisito tramite',
        ReasonCode: 'Codice motivo',
        Email: 'Email',
        ID: 'ID',
        DateOfIssue: 'Data di emissione',
        DateOfExpiry: 'Data di scadenza',
        Outcomes: 'Risultati',
        VoucherID: 'ID voucher',
        NoOutcome: 'nessun risultato',
        NoExpiry: 'nessuna scadenza',
        SorrySomethingWentWrong: 'Siamo spiacenti, qualcosa è andato storto!',
        All: 'Tutto',
        Issued: 'Rilasciato',
        Redeem: 'Riscattare',
        Expired: 'Scaduto',
        Pending: 'In attesa di',
        CustomerSupport: 'Assistenza clienti',
        PendingColumns: {
          RequestID: 'Richiesta ID',
          Status: 'Stato',
          Reason: 'Motivo',
          NumberOfTries: 'Numero di tentativi',
          DateOfRequest: 'Data della richiesta',
          Actions: 'Azioni'
        },
        ApproveIssue: 'Approvare il problema',
        ViewComments: 'Visualizza commenti',
        ViewAndAddComments: 'Visualizza e aggiungi commenti',
        ApproveIssueSuccessMessage: 'La richiesta è stata approvata',
        ApproveIssueErrorMessage: 'Qualcosa è andato storto',
        ApproveDenyModal: {
          Title: 'Approvare il problema dei premi',
          OkText: 'Approvare',
          CancelText: 'Cancellare',
          Description: "Sei sicuro di voler approvare l'emissione di questa ricompensa? "
        },
        CustomerCardView: {
          Slot: 'Slot n.',
          StampId: 'Timbro identificativo',
          Status: 'Stato',
          AcquiredVia: 'Acquisito tramite',
          StampIssuedDate: 'Data di emissione del timbro',
          StampRedeemedDate: 'Timbro riscatto della data',
          Outcomes: 'Risultati',
          RedeemTheStamp: 'Riscatta il timbro',
          EmptySlots: 'Slot vuoti',
          SlotEmpty: 'Slot vuoto',
          ID: 'ID',
          VoucherID: 'ID del buono',
          RewardID: 'Ricompensa ID',
          NoRewards: 'Nessun premio emesso',
          NoRewardsIssued: 'Nessun premio emesso',
          Note: 'Nota',
          Email: 'E-mail',
          SorrySomethingWentWrong: 'Scusa, qualcosa è andato storto'
        }
      },

      CustomerQuizAndSurveyView: {
        QuestionNo: 'Domanda n.',
        Question: 'Domanda',
        Response: 'Risposta',
        SubmissionDateOrTime: 'Data / Ora di invio',
        Result: 'Risultato'
      },

      IssueGameChangeModal: {
        MakerCheckerSuccessMessage:
          'Richiesta di emissione possibilità di gioco inviata per approvazione',
        SuccessMessage: 'Possibilità di gioco emesse con successo!',
        ErrorMessage: 'Errore nell’emissione delle possibilità di gioco',
        IssueGameTriesButton: 'Emetti tentativi di gioco',
        Title: 'Emetti possibilità di gioco a',
        OkText: 'Emetti possibilità',
        HowManyChances: 'Quante possibilità?',

        IssueGameChanceButton: 'Distribuisci la possibilità di gioco',
        ReasonForIssuance: "Motivo dell'emissione",
        ChanceCountValidationMessage: 'Si prega di specificare un conteggio delle possibilità.',
        ReasonForIssuanceValidationMessage: "Si prega di specificare un motivo per l'emissione."
      },

      CustomerStampCards: {
        CardHash: 'Carta #',
        StampCardID: 'ID carta timbro',
        State: 'Stato',
        ExpiryDate: 'Data di scadenza',
        DateOfParticipation: 'Data di partecipazione',
        StampsCollected: 'Timbri raccolti',
        CompletedDate: 'Data di completamento',
        RewardsAchieved: 'Ricompense raggiunte',

        PendingColumns: {
          RequestID: 'Richiesta ID',
          State: 'Stato',
          Reason: 'Motivo',
          NumberOfStamps: 'Numero di francobolli',
          DateOfRequest: 'Data della richiesta',
          Actions: 'Azioni'
        },
        CancelIssuance: "Annullare l'emissione",
        ApproveIssue: 'Approvare il problema',
        ApproveIssueSuccessMessage: 'La richiesta è stata approvata',
        ApproveIssueErrorMessage: 'Qualcosa è andato storto',
        ViewComments: 'Visualizza i commenti',
        Active: 'Attivo',
        Completed: 'Completato',
        Expired: 'Scaduto',
        Pending: 'In attesa di',
        SorrySomethingWentWrong: 'Scusa, qualcosa è andato storto'
      },

      IssueStampsModal: {
        MakerCheckerSuccessMessage: 'Richiesta di emissione timbri inviata per approvazione',
        SuccessMessage: 'Emissione timbri riuscita!',
        IssueStampsButton: 'Emetti timbri',
        Title: 'Emetti timbri a',
        OkText: 'Emetti timbri',
        HowManyStamps: 'Quanti timbri?',

        ErrorMessage: "Errore nell'emissione dei francobolli",
        CancelText: 'Cancellare',
        ReasonForIssuance: "Motivo per l'emissione",
        CustomerFullNameDefault: 'Cliente attuale',
        StampsCountValidationMessage: 'Si prega di specificare il numero di francobolli.',
        ReasonToIssuanceValidationMessage: "Si prega di specificare un motivo per l'emissione"
      },

      DeleteRequestModal: {
        SuccessMessage: 'La richiesta è stata annullata',
        ErrorMessage: 'Qualcosa è andato storto',
        Title: 'Cancellare {{type}} Richiesta di emissione?',
        OkText: 'Confermare',
        CancelText: 'Cancellare',
        DescriptionLineOne: 'Questo {{lowerCaseType}} è in attesa di approvazione. ',
        DescriptionLineTwo:
          'Una volta approvata la cancellazione, questo {{lowerCaseType}} non sarà disponibile e dovrai crearlo di nuovo.'
      },

      IssueRewardModal: {
        RewardIssuedSuccessfully: 'Ricompensa emessa con successo!',
        ErrorIssueReward: 'Errore nell’emissione della ricompensa',
        IssueRewardTitle: 'Emetti ricompense',
        IssueRewardOkText: 'Emetti ricompensa',
        IssueRewardButton: 'Emetti ricompensa',
        ReasonForAdjustment: 'Motivo dell’aggiustamento',
        PleaseSpecifyAReasonForAdjustment:
          'Si Pregherezza Di Specificare Una Motivazione Per La Regolazione'
      },

      ProgressPointsPendingView: {
        RequestID: 'ID richiesta',
        Status: 'Stato',
        Reason: 'Motivo',
        NumberOfPoints: 'Numero di punti',
        DateOfRequest: 'Data della richiesta',
        Actions: 'Azioni',
        ApproveRequest: 'Approva richiesta',
        CancelIssuance: "Annulla l'emissione",
        ViewComments: 'Visualizza commenti',
        ViewAndAddComments: 'Visualizza e aggiungi commenti',
        ApproveRequestSuccessMessage: 'La richiesta è stata approvata',
        ApproveRequestErrorMessage: 'Qualcosa è andato storto',
        Pending: 'In attesa',
        Completed: 'Completato',
        All: 'Tutto',
        ApproveDenyModal: {
          Title: "Approva l'emissione di punti progresso",
          OkText: 'Approva',
          CancelText: 'Annulla',
          Description:
            'Sei sicuro di voler approvare questa emissione di punti progresso? Questa azione non può essere annullata.'
        }
      },

      QuestTaskPendingView: {
        RequestID: 'ID richiesta',
        Status: 'Stato',
        Task: 'Attività',
        Reason: 'Motivo',
        DateOfRequest: 'Data della richiesta',
        Actions: 'Azioni',
        ApproveRequest: 'Approva richiesta',
        CancelIssuance: "Annulla l'emissione",
        ViewComments: 'Visualizza commenti',
        ViewAndAddComments: 'Visualizza e aggiungi commenti',
        ApproveRequestSuccessMessage: 'La richiesta è stata approvata',
        ApproveRequestErrorMessage: 'Qualcosa è andato storto',
        Pending: 'In attesa',
        Completed: 'Completato',
        All: 'Tutto',
        ReasonForCompletion: 'Motivo del completamento',
        ReasonRequired: 'Si prega di specificare un motivo',
        ReasonModalTitle: 'Segna attività quest come completata',
        ReasonModalOkText: 'Invia',
        RequestSubmittedForApproval: "Richiesta inviata per l'approvazione",
        ApproveDenyModal: {
          Title: "Approva il completamento dell'attività quest",
          OkText: 'Approva',
          CancelText: 'Annulla',
          Description:
            "Sei sicuro di voler approvare questo completamento dell'attività quest? Questa azione non può essere annullata."
        }
      },

      InstantRewardPendingView: {
        RequestID: 'ID richiesta',
        Status: 'Stato',
        Reason: 'Motivo',
        DateOfRequest: 'Data della richiesta',
        Actions: 'Azioni',
        ApproveRequest: 'Approva richiesta',
        CancelIssuance: "Annulla l'emissione",
        ViewComments: 'Visualizza commenti',
        ViewAndAddComments: 'Visualizza e aggiungi commenti',
        ApproveRequestSuccessMessage: 'La richiesta è stata approvata',
        ApproveRequestErrorMessage: 'Qualcosa è andato storto',
        Pending: 'In attesa',
        Completed: 'Completato',
        All: 'Tutto',
        RequestSubmittedForApproval: "Richiesta inviata per l'approvazione",
        ApproveDenyModal: {
          Title: "Approva l'emissione di ricompensa istantanea",
          OkText: 'Approva',
          CancelText: 'Annulla',
          Description:
            'Sei sicuro di voler approvare questa emissione di ricompensa istantanea? Questa azione non può essere annullata.'
        }
      },

      RaffleTicketPendingView: {
        RequestID: 'ID richiesta',
        Status: 'Stato',
        Reason: 'Motivo',
        DateOfRequest: 'Data della richiesta',
        Actions: 'Azioni',
        ApproveRequest: 'Approva richiesta',
        CancelIssuance: "Annulla l'emissione",
        ViewComments: 'Visualizza commenti',
        ViewAndAddComments: 'Visualizza e aggiungi commenti',
        ApproveRequestSuccessMessage: 'La richiesta è stata approvata',
        ApproveRequestErrorMessage: 'Qualcosa è andato storto',
        Pending: 'In attesa',
        Issued: 'Emesso',
        All: 'Tutto',
        RequestSubmittedForApproval: "Richiesta inviata per l'approvazione",
        ApproveDenyModal: {
          Title: "Approva l'emissione del biglietto lotteria",
          OkText: 'Approva',
          CancelText: 'Annulla',
          Description:
            'Sei sicuro di voler approvare questa emissione del biglietto lotteria? Questa azione non può essere annullata.'
        }
      },

      AddRemovePointsModal: {
        RequestSubmittedForApproval: "Richiesta inviata per l'approvazione",
        PointsUpdatedSuccessfully: 'Punti aggiornati con successo!',
        ErrorUpdatingPoints: 'Errore nell’aggiornamento dei punti',
        AddOrRemovePointsButton: 'Aggiungi/Rimuovi punti',
        AdjustProgressCampaignPoints: 'Regola punti campagna progresso',
        OkText: 'Regola punti',
        HowManyPointsToAddOrRemove: 'Quanti punti aggiungere/rimuovere?',
        ReasonForAdjustment: 'Motivo dell’aggiustamento'
      }
    },

    CustomerStamps: {
      All: 'Tutto',
      Active: 'Attivo',
      Inactive: 'Inattivo',
      Name: 'Nome',
      Status: 'Stato',
      Started: 'Iniziato',
      Ended: 'Finito',
      ID: 'ID',
      SearchPlaceholder: 'Trova una campagna per nome',
      EnrollCampaignModal: {
        SuccessMessage: 'La campagna ha registrato successo!',
        ErrorMessage: 'Campagna iscritta fallita.',
        CampaignIDValidationMessage: 'Specifica una campagna',
        FullNameDefault: 'Cliente attuale',
        ManualEnrollButton: 'Iscrizione manuale',
        Title: 'Iscriversi',
        OkText: 'Iscrivi cliente',
        CancelText: 'Cancellare'
      },

      CampaignSelectField: {
        Label: 'Seleziona Campagna',
        Edit: 'Modificare',
        Add: 'Aggiungere',
        Campaign: 'Campagna'
      },

      CampaignSelectModal: {
        Title: 'Seleziona una campagna',
        CancelText: 'Cancellare',
        OkText: 'Aggiungi campagna',
        SearchPlaceholder: 'Trova una campagna per nome, tipo o commerciante',
        Name: 'Nome',
        ID: 'ID',
        Status: 'Stato',
        Tags: 'Tag',
        StartDate: 'Data di inizio',
        EndDate: 'Data di fine'
      }
    },
    CustomerGames: {
      Name: 'Nome',
      ID: 'ID',
      Status: 'Stato',
      GameType: 'Tipo di gioco',
      TriesRedeemed: 'Prova riscattato',
      Started: 'Iniziato',
      Ended: 'Concluso',
      SearchPlaceholder: 'Trova una campagna per nome',
      SorrySomethingWentWrong: 'Scusa, qualcosa è andato storto',
      Tabs: {
        All: 'Tutto',
        Active: 'Attivo',
        Approved: 'Approvato',
        Inactive: 'Inattivo',
        Ended: 'Finito'
      }
    }
  }
};
